import React from 'react';
import { useState, useEffect } from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
//import ChangingProgressProvider from '../../ProgressBar/ChangingProgressProvider';
import { MdFullscreen } from "react-icons/md";
//import 'react-circular-progressbar/dist/styles.css';
import './Gallery8.css'
import '../../styles/style.css'
import zagMainImage from '../../../assets/works/zag/main/zag-main-storm-min.jpg';
import zagRelatedTreeRight from '../../../assets/works/zag/related/zag-related-tree-right-min.jpg';
import zagRelatedTreeCentered from '../../../assets/works/zag/related/zag-related-tree-centered-min.jpg';
import zagRelatedGardenWide from '../../../assets/works/zag/related/zag-related-garden-wide-min.jpg';
import zagRelatedTreeClose from '../../../assets/works/zag/related/zag-related-tree-close-min.jpg';

//compressed images
import thumbnail1 from './thumbnails/1_man_woman_blue-min.jpg'
import thumbnail2 from './thumbnails/2_egyptains_dancing-min.jpg'
import thumbnail3 from './thumbnails/3_watch_over_me-min.jpg'
import thumbnail4 from './thumbnails/4_the_ancients-min.jpg'
import thumbnail5 from './thumbnails/5_red_flower-min.jpg'
import thumbnail6 from './thumbnails/6_free_bird-min.jpg'
import thumbnail7 from './thumbnails/7_nude_descending-min.jpg'
import thumbnail8 from './thumbnails/8_keep_on_trucking-min.jpg'
import thumbnail9 from './thumbnails/9_metropolis-min.jpg'
import thumbnail10 from './thumbnails/10_sail_dream-min.jpg'
import thumbnail11 from './thumbnails/11_boat-min.jpg'
import thumbnail12 from './thumbnails/12_bird_brain-min.jpg'
import thumbnail13 from './thumbnails/13_gate_main.jpg'
import thumbnail14 from './thumbnails/14_dancer_facing_top-min.jpg'

import realtedThumbnail1 from './related_thumbs/1_1_man_woman_blue_close-min.jpg'
import relatedThumb11 from './related_thumbs/2_1_boat_back-min.jpg'
import relatedThumb3 from './related_thumbs/3_watch_japanese_related-min.jpg'
import relatedThumb4 from './related_thumbs/4_1_ancient_side.jpg';
import relatedThumb4_1 from './related_thumbs/4_2_ancient_side.jpg';
import relatedthumbnail13 from './related_thumbs/13_1_gate_related.jpg'
import relatedthumbnail13_1 from './related_thumbs/13_gate_related_1.jpg'
import relatedthumbnail9 from './related_thumbs/9_1_metro_close.jpg'
import relatedthumbnail10 from './related_thumbs/10_sail_dream_other.jpg'
import relatedthumbnail14 from './related_thumbs/14_1_dancer_facing_out-min.jpg'
import relatedthumbnail14_1 from './related_thumbs/14_2_dancer_facing-min.jpg'

function GalleryEight() {

    const zagRelatedViews = [
        { image: zagRelatedTreeRight, heading: 'ZAG (Tree Right View)' },
        { image: zagRelatedTreeCentered, heading: 'ZAG (Centered Tree View)' },
        { image: zagRelatedGardenWide, heading: 'ZAG (Garden Wide View)' },
        { image: zagRelatedTreeClose, heading: 'ZAG (Tree Close View)' }
    ]
    const [relatedImage, setRelatedImages] = useState(zagRelatedViews.map(({ image }) => image));
    const [currentDisplayImage, setCurrentDisplayImage] = useState(zagMainImage);
    const [mainImageOnDisplay, setMainImageOnDisplay] = useState(15);
    const [displayImageHeading, setDisplayImageHeading] = useState('ZAG');
    const [displayImageSize, setDisplayImageSize] = useState('77" x 26" x 19.5"');
    const [displayImageMaterial, setDisplayImageMaterial] = useState('Stainless Steel');
    const [fullScreen, setFullScreen] = useState(false);

    const relatedImages1 = [realtedThumbnail1]
    const relatedImages2 = []
    const relatedImages3 = [relatedThumb3]
    const relatedImages4 = [relatedThumb4, relatedThumb4_1]
    const relatedImages5 = []
    const relatedImages6 = []
    const relatedImages7 = []
    const relatedImages8 = []
    const relatedImages9 = [relatedthumbnail9]
    const relatedImages10 = [relatedthumbnail10]
    const relatedImages11 = [relatedThumb11]
    const relatedImages12 = []
    const relatedImages13 = [relatedthumbnail13, relatedthumbnail13_1]
    const relatedImages14 = [relatedthumbnail14, relatedthumbnail14_1]
    const relatedImages15 = zagRelatedViews.map(({ image }) => image)

    useEffect(() => {
        const timer = setTimeout(() => {
            const progressBar = document.querySelector(".loadingContainer");
            const mainImageGrid = document.querySelector(".mainGalleryEightContainer");
            if (progressBar) progressBar.style.display = "none";
            if (mainImageGrid) mainImageGrid.style.display = "block";
        }, 1200);

        return () => clearTimeout(timer); // Cleanup on unmount
    }, []);

    function updateFromRelated(elementURL, element) {
        var big_image = document.getElementById('display_image')
        big_image.src = elementURL
        console.log('updateFromRelated')
        console.log('mainImageOnDisplay:' + mainImageOnDisplay + ' element:' + element.target.id)

        if (mainImageOnDisplay === 15) {
            const zagView = zagRelatedViews[Number(element.target.id)]
            if (zagView) {
                setDisplayImageHeading(zagView.heading)
                setCurrentDisplayImage(zagView.image)
            }
        }
        else if (mainImageOnDisplay == 2 && element.target.id == 0) {
            console.log('came')
            setDisplayImageHeading('Boat Couch (Back View)')
            setDisplayImageMaterial('Made from stem bent oak ribs, cedar planking, and oak and mahogany trim')
            setCurrentDisplayImage(relatedThumb11)
        }
        else if (mainImageOnDisplay == 3 && element.target.id == 0) {
            setDisplayImageHeading('Watch Over Me Japanese (Other Side)')
            setCurrentDisplayImage(relatedThumb3)
        }
        else if (mainImageOnDisplay == 13 && element.target.id == 0) {
            setDisplayImageHeading('Go Away Gate (Close Up)')
        }
        else if (mainImageOnDisplay == 13 && element.target.id == 1) {
            setDisplayImageHeading('Go Away Gate (Alternate View)')
        }
    }

    function updateImage(element) {
        console.log("imgae hover called on : " + element.target.id)
        var image = document.getElementById(element.target.id)
        var big_image = document.getElementById('display_image')
        big_image.src = image.src

        switch (element.target.id) {
            case '15':
                setRelatedImages(relatedImages15)
                setCurrentDisplayImage(zagMainImage)
                setMainImageOnDisplay(15)
                setDisplayImageHeading('ZAG')
                setDisplayImageSize('77" x 26" x 19.5"')
                setDisplayImageMaterial('Stainless Steel')
                break;
            case '1':
                setRelatedImages(relatedImages1)
                setCurrentDisplayImage(thumbnail1)
                setMainImageOnDisplay(1)
                setDisplayImageHeading('Man Women Blue')
                setDisplayImageSize('15" x 32" x 61"')
                setDisplayImageMaterial('Powder Coated Steel, Granite Base')
                break;
            case '2':
                setRelatedImages(relatedImages2)
                setCurrentDisplayImage(thumbnail2)
                setMainImageOnDisplay(2)
                setDisplayImageHeading('Dance')
                setDisplayImageSize('46" x 23" x 3.5"')
                setDisplayImageMaterial('Stainless Steel, Steel')
                break;
            case '3':
                setRelatedImages(relatedImages3)
                setCurrentDisplayImage(thumbnail3)
                setMainImageOnDisplay(3)
                setDisplayImageHeading('Watch Over Me Japanese')
                setDisplayImageSize('108" (9 ft) x 42" x 7"')
                setDisplayImageMaterial('Fiberglass, Stainless Steel, Paint')
                break;
            case '4':
                setRelatedImages(relatedImages4)
                setCurrentDisplayImage(thumbnail4)
                setMainImageOnDisplay(4)
                setDisplayImageHeading('The Ancients')
                setDisplayImageSize('7" x 6" x 4"')
                setDisplayImageMaterial('Distressed Paint Finish')
                break;
            case '5':
                setRelatedImages(relatedImages5)
                setCurrentDisplayImage(thumbnail5)
                setMainImageOnDisplay(5)
                setDisplayImageHeading('Red Flowers')
                setDisplayImageSize('4" x 18"')
                setDisplayImageMaterial('Stainless Steel Brushed and Painted Finish')
                break;
            case '6':
                setRelatedImages(relatedImages6)
                setCurrentDisplayImage(thumbnail6)
                setMainImageOnDisplay(6)
                setDisplayImageHeading('Freebirds with Snake')
                setDisplayImageSize('108" x 22" x 18"')
                setDisplayImageMaterial('Stainless Steel and Wood')
                break;
            case '7':
                setRelatedImages(relatedImages7)
                setCurrentDisplayImage(thumbnail7)
                setMainImageOnDisplay(7)
                setDisplayImageHeading('Nude Descending')
                setDisplayImageSize('61" x 31" x 1/2"')
                setDisplayImageMaterial('Stainless Steel, Brushed Finish')
                break;
            case '8':
                setRelatedImages(relatedImages8)
                setCurrentDisplayImage(thumbnail8)
                setMainImageOnDisplay(8)
                setDisplayImageHeading('Keep on Trucking')
                setDisplayImageSize('86" x 19" x 4"')
                setDisplayImageMaterial('Stainless Steel')
                break;
            case '9':
                setRelatedImages(relatedImages9)
                setCurrentDisplayImage(thumbnail9)
                setMainImageOnDisplay(9)
                setDisplayImageHeading('Metropolis')
                setDisplayImageSize('34" x 24" x 44"')
                setDisplayImageMaterial('Poll Mount, Rotates and Wobbles on Axis \nStainless Steel Brushed and Painted Finish');
                break;
            case '10':
                setRelatedImages(relatedImages10)
                setCurrentDisplayImage(thumbnail10)
                setMainImageOnDisplay(10)
                setDisplayImageHeading('Sail Dream')
                setDisplayImageSize('43" X 24" 69"')
                setDisplayImageMaterial('Aluminum')
                break;
            case '11':
                setRelatedImages(relatedImages11)
                setCurrentDisplayImage(thumbnail11)
                setMainImageOnDisplay(11)
                setDisplayImageHeading('Boat Couch')
                setDisplayImageSize('')
                setDisplayImageMaterial('Made from stem bent oak ribs, cedar planking, and oak and mahogany trim')
                break;
            case '12':
                setRelatedImages(relatedImages12)
                setCurrentDisplayImage(thumbnail12)
                setMainImageOnDisplay(12)
                setDisplayImageHeading('Bird Brain')
                setDisplayImageSize('6" X 4" 3/8"')
                setDisplayImageMaterial('Stainless Steel ground and brushed finish')
                break;
            case '13':
                setRelatedImages(relatedImages13)
                setCurrentDisplayImage(thumbnail13)
                setMainImageOnDisplay(13)
                setDisplayImageHeading('Go Away Gate')
                setDisplayImageSize('5" X 5" 3"')
                setDisplayImageMaterial('Steel')
                break;
            case '14':
                setRelatedImages(relatedImages14)
                setCurrentDisplayImage(thumbnail14)
                setMainImageOnDisplay(14)
                setDisplayImageHeading('Shadow Dancers')
                setDisplayImageSize('5" X 6"')
                setDisplayImageMaterial('Stainless Steel brushed finish')
                break;
            default:
                setRelatedImages([])
                break;
        }
    }

    function openFullScreen(element) {
        console.log("full screen called")
        // var image = document.getElementsByClassName('displayImageContainer')
        const DIV = document.querySelector('#display_image');
        if (DIV.requestFullscreen) {
            DIV.requestFullscreen();
        } else if (DIV.msRequestFullscreen) {
            DIV.msRequestFullscreen();
        } else if (DIV.mozRequestFullScreen) {
            DIV.mozRequestFullScreen();
        } else if (DIV.webkitRequestFullscreen) {
            DIV.webkitRequestFullscreen();
        }

        setFullScreen(true)
    }

    function closeFullScreen(element) {
        if (fullScreen) {
            console.log("close full screen called")
            document.exitFullscreen()
            setFullScreen(false)
        }
    }

    function openFullScreenMobile(element) {
        console.log("full screen called")
        console.log(element.target.id)
        const image = document.getElementById(element.target.id)
        image.requestFullscreen()
    }

    return (

        <div className="galleryEight">

            {/* this is the progress bar */}
            <div className="loadingContainer">
                <div className='loadingProgressBar' style={{ width: 360, height: 360 }}>
                  <DotLottieReact
                        src="https://lottie.host/604b3c66-6b78-457b-8cdd-e25d8456c6a3/pJ5f47DXkb.lottie"
                        loop
                        autoplay
                    />
                </div>
            </div>
            {/* <LoadingContainer></LoadingContainer> */}

            {/*This is for DESKTOP VIEW*/}
            <div className='mainGalleryEightContainer'>
                <div className='galleryEightContainer'>
                    <div className='firstContainer'>
                        <div className='row-tiny'>
                            <img className='imageCard' id='15' onMouseOver={(e) => updateImage(e)} onClick={(e) => updateImage(e)} src={zagMainImage} alt='gallery8'></img>
                            <img className='imageCard' id='1' onMouseOver={(e) => updateImage(e)} onClick={(e) => updateImage(e)} src={thumbnail1} alt='gallery8'></img>
                            <img className='imageCard' id='2' onMouseOver={(e) => updateImage(e)} onClick={(e) => updateImage(e)} src={thumbnail2} alt='gallery8'></img>
                        </div>
                        <div className='row-tiny'>
                            <img className='imageCard' id='3' onMouseOver={(e) => updateImage(e)} onClick={(e) => updateImage(e)} src={thumbnail3} alt='gallery8'></img>
                            <img className='imageCard' id='4' onMouseOver={(e) => updateImage(e)} onClick={(e) => updateImage(e)} src={thumbnail4} alt='gallery8'></img>
                            <img className='imageCard' id='5' onMouseOver={(e) => updateImage(e)} onClick={(e) => updateImage(e)} src={thumbnail5} alt='gallery8'></img>
                        </div>
                        <div className='row-tiny'>
                            <img className='imageCard' id='6' onMouseOver={(e) => updateImage(e)} onClick={(e) => updateImage(e)} src={thumbnail6} alt='gallery8'></img>
                            <img className='imageCard' id='7' onMouseOver={(e) => updateImage(e)} onClick={(e) => updateImage(e)} src={thumbnail7} alt='gallery8'></img>
                            <img className='imageCard' id='8' onMouseOver={(e) => updateImage(e)} onClick={(e) => updateImage(e)} src={thumbnail8} alt='gallery8'></img>
                        </div>
                        <div className='row-tiny'>
                            <img className='imageCard' id='9' onMouseOver={(e) => updateImage(e)} onClick={(e) => updateImage(e)} src={thumbnail9} alt='gallery8'></img>
                            <img className='imageCard' id='10' onMouseOver={(e) => updateImage(e)} onClick={(e) => updateImage(e)} src={thumbnail10} alt='gallery8'></img>
                            <img className='imageCard' id='11' onMouseOver={(e) => updateImage(e)} onClick={(e) => updateImage(e)} src={thumbnail11} alt='gallery8'></img>
                        </div>
                        <div className='row-tiny'>
                            <img className='imageCard' id='12' onMouseOver={(e) => updateImage(e)} onClick={(e) => updateImage(e)} src={thumbnail12} alt='gallery8'></img>
                            <img className='imageCard' id='13' onMouseOver={(e) => updateImage(e)} onClick={(e) => updateImage(e)} src={thumbnail13} alt='gallery8'></img>
                            <img className='imageCard' id='14' onMouseOver={(e) => updateImage(e)} onClick={(e) => updateImage(e)} src={thumbnail14} alt='gallery8'></img>
                        </div>

                    </div>
                    <div className='secondContainer'>

                        <div className='displayImageContainer'>
                            <div className='displayImageOne'>
                                <img id='display_image' src={currentDisplayImage} onClick={(e) => closeFullScreen(e)} alt='display_image' width={'auto'} height={'auto'} ></img>
                            </div>
                            <div className='displayImageTwo'>
                                <div className='related_images'>
                                    {relatedImage.map((url, index) => {
                                        return <img className='related_images_thumb' id={index} onMouseOver={(e) => updateFromRelated(url, e)} key={index} src={url} alt='related_image' width={'auto'} height={'auto'}></img>
                                    })}
                                </div>
                                <MdFullscreen id="fullScreenIcon" size={36} onClick={(e) => openFullScreen(e)} />
                                <div id='display_image_information'>
                                    <h3 id='display_image_heading'>{displayImageHeading}</h3>
                                    <h6 id='display_image_size'>{displayImageSize}</h6>
                                    <h6 id='display_image_material'>{displayImageMaterial}</h6>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>

            {/*This is for MOBILE VIEW*/}
            <div className='gallery_mobile'>
                <div className='mobileColumn'>
                    <img className='imageCardMobile' id='mobile_15' src={zagMainImage} onClick={(e) => openFullScreenMobile(e)} alt='gallery8'></img>
                    <img className='imageCardMobile' id='mobile_1' src={thumbnail1} onClick={(e) => openFullScreenMobile(e)} alt='gallery8'></img>
                    <img className='imageCardMobile' id='mobile_2' src={thumbnail2} onClick={(e) => openFullScreenMobile(e)} alt='gallery8'></img>
                    <img className='imageCardMobile' id='mobile_3' src={thumbnail3} onClick={(e) => openFullScreenMobile(e)} alt='gallery8'></img>
                </div>
                <div className='mobileColumn'>
                    <img className='imageCardMobile' id='mobile_4' src={thumbnail4} onClick={(e) => openFullScreenMobile(e)} alt='gallery8'></img>
                    <img className='imageCardMobile' id='mobile_5' src={thumbnail5} onClick={(e) => openFullScreenMobile(e)} alt='gallery8'></img>
                    <img className='imageCardMobile' id='mobile_6' src={thumbnail6} onClick={(e) => openFullScreenMobile(e)} alt='gallery8'></img>
                </div>
                <div className='mobileColumn'>
                    <img className='imageCardMobile' id='mobile_7' src={thumbnail7} onClick={(e) => openFullScreenMobile(e)} alt='gallery8'></img>
                    <img className='imageCardMobile' id='mobile_8' src={thumbnail8} onClick={(e) => openFullScreenMobile(e)} alt='gallery8'></img>
                    <img className='imageCardMobile' id='mobile_9' src={thumbnail9} onClick={(e) => openFullScreenMobile(e)} alt='gallery8'></img>
                </div>
                <div className='mobileColumn'>
                    <img className='imageCardMobile' id='mobile_10' src={thumbnail10} onClick={(e) => openFullScreenMobile(e)} alt='gallery8'></img>
                    <img className='imageCardMobile' id='mobile_11' src={thumbnail11} onClick={(e) => openFullScreenMobile(e)} alt='gallery8'></img>
                    <img className='imageCardMobile' id='mobile_12' src={thumbnail12} onClick={(e) => openFullScreenMobile(e)} alt='gallery8'></img>
                </div>
                <div className='mobileColumn'>
                    <img className='imageCardMobile' id='mobile_13' src={thumbnail13} onClick={(e) => openFullScreenMobile(e)} alt='gallery8'></img>
                    <img className='imageCardMobile' id='mobile_14' src={thumbnail14} onClick={(e) => openFullScreenMobile(e)} alt='gallery8'></img>
                </div>
            </div>

        </div>

    )

}

export default GalleryEight;
